import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

import * as _ from 'lodash';

import { environment } from 'environments/environment';
import { CommonService } from '../../../../../common/services/Common.service';
import { UploadService } from '../../../../../common/services/Upload.service';
import { ChatService } from '../../../../../common/services/Chat.service';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'chat-config',
  templateUrl: './chat_config.component.html',
  styleUrls: [],
  providers: [CommonService],
})
@Injectable()
export class ChatConfigComponent implements OnInit {
  public model: any = {};
  public embed: any = '';
  public tab: any = 'tab-config';
  constructor(
    private commonService: CommonService,
    private uploadService: UploadService,
    private chatService: ChatService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    const user = JSON.parse(localStorage.getItem('User'));
    const _tenant_id = user.tenant_id ? user.tenant_id : user.id;
    // this.embed = `<script type="text/javascript">window.addEventListener("message", function (event) {var viewportWidth = window.innerWidth || document.documentElement.clientWidth; if (event.data.action === 'resizeIframe' && viewportWidth <= 768) {document.getElementById('3c_chat_iframe').style.width = event.data.width;document.getElementById('3c_chat_iframe').style.height = '88vh';}else{document.getElementById('3c_chat_iframe').style.width = "100%";document.getElementById('3c_chat_iframe').style.height = "520px";}if(event.data.message == "closeChatBox"){document.getElementById('3c-live-chat').style.width = "fit-content";document.getElementById('3c-live-chat').style.height = "fit-content";document.getElementById('3c_chat_iframe').style.width = "fit-content";document.getElementById('3c_chat_iframe').style.height = "fit-content";}if( event.data.message == "openChatBox"  && viewportWidth <= 768){document.getElementById('3c_chat_iframe').style.width = "100vw";document.getElementById('3c_chat_iframe').style.height = "88vh";}}); function loadJsAsync(t, e) { var n = document.createElement("script"); n.type = "text/javascript", n.src = t, n.addEventListener("load", function (t) { e(null, t) }, !1); var a = document.getElementsByTagName("head")[0]; a.appendChild(n) } window.addEventListener("DOMContentLoaded", function () { loadJsAsync("${environment.url_embed}/js/3cChat.js?v=2.1", function () { var t = { domain: "", tenant_id: '${_tenant_id}' }; embedCsChat(t) }) }, !1);</script>`;
    this.embed = `
        <script type="text/javascript">
        window.addEventListener("message", function (event) {
          var viewportWidth =
            window.innerWidth || document.documentElement.clientWidth;

          console.log(event.data);
          if (viewportWidth <= 768) {
            document.body.scrollTo({ top: 0, behavior: "smooth" });
            if (document.getElementById("3c_chat_iframe")) {
              document.getElementById("3c_chat_iframe").style.width =
                event.data.width;
              document.getElementById("3c_chat_iframe").style.height = "84vh";
              document.getElementById("3c_chat_iframe").style.position = "fixed";
            }
          } else {
            if (document.getElementById("3c_chat_iframe")) {
              document.getElementById("3c_chat_iframe").style.width = "100%";
              document.getElementById("3c_chat_iframe").style.height = "520px";
            }
          }
          if (event.data.message == "closeChatBox") {
            if (document.getElementById("3c-live-chat")) {
              document.getElementById("3c-live-chat").style.width = "fit-content";
              document.getElementById("3c-live-chat").style.height =
                "fit-content";
            }
            document.getElementById("3c_chat_iframe").style.width = "180px";
            document.getElementById("3c_chat_iframe").style.height = "120px";
          }
          if (event.data.message == "openChatBox" && viewportWidth <= 768) {
            if (document.getElementById("3c_chat_iframe")) {
              document.getElementById("3c_chat_iframe").style.position = "fixed";
              document.getElementById("3c_chat_iframe").style.width = "100vw";
              document.getElementById("3c_chat_iframe").style.height = "84vh";
            }
          }
        });
        function loadJsAsync(t, e) {
          var n = document.createElement("script");
          (n.type = "text/javascript"),
            (n.src = t),
            n.addEventListener(
              "load",
              function (t) {
                e(null, t);
              },
              !1
            );
          var a = document.getElementsByTagName("head")[0];
          a.appendChild(n);
        }
        window.addEventListener(
          "DOMContentLoaded",
          function () {
            var meta = document.createElement('meta');
      meta.setAttribute('name', 'viewport');
      meta.setAttribute('content', 'width=device-width, initial-scale=1.0, user-scalable=no');

      // Tìm thẻ head và chèn thẻ meta mới vào đó
      var head = document.querySelector('head');
      head.appendChild(meta);
            loadJsAsync(
              "${environment.url_embed}/js/3cChat.js?v=2.1",
              function () {
                var t = { domain: "", tenant_id: '${_tenant_id}' };
                embedCsChat(t);

                var viewportWidth =
                  window.innerWidth || document.documentElement.clientWidth;
                console.log(viewportWidth);
                if (viewportWidth <= 768) {
                  document.getElementById("3c_chat_iframe").style.position =
                    "fixed";
                  document.getElementById("3c_chat_iframe").style.height = "84vh";
                } else {
                  console.log(123123);
                  document.getElementById("3c_chat_iframe").style.height =
                    "520px";
                }
                window.addEventListener("message", function (event) {
                  if (viewportWidth <= 768) {
                    document.getElementById("3c_chat_iframe").style.position =
                      "fixed";
                    document.body.scrollTo({ top: 0, behavior: "smooth" });
                    if (document.getElementById("3c_chat_iframe")) {
                      document.getElementById("3c_chat_iframe").style.height =
                        "84vh";
                    }
                  } else {
                    if (document.getElementById("3c_chat_iframe")) {
                      document.getElementById("3c_chat_iframe").style.width =
                        "100%";
                      document.getElementById("3c_chat_iframe").style.height =
                        "520px";
                    }
                  }
                  if (event.data.message == "closeChatBox") {
                    if (document.getElementById("3c-live-chat")) {
                      document.getElementById("3c-live-chat").style.width =
                        "fit-content";
                      document.getElementById("3c-live-chat").style.height =
                        "fit-content";
                    }

                    (document.getElementById("3c_chat_iframe").style.width =
                      "180px"),
                      (document.getElementById("3c_chat_iframe").style.height =
                        "120px");
                  }
                  if (
                    event.data.message == "openChatBox" &&
                    viewportWidth <= 768
                  ) {
                    (document.getElementById("3c_chat_iframe").style.position =
                      "fixed"),
                      (document.getElementById("3c_chat_iframe").style.width =
                        "100vw"),
                      (document.getElementById("3c_chat_iframe").style.height =
                        "84vh");
                  }
                });
              }
            );
          },
          !1
        );
      </script>

        `;

    this.loadData();
  }

  loadData(request: any = {}) {
    this.chatService.config().subscribe(res => {
      if (!res.error) {
        this.model = res.data ? res.data : {};
        if (this.model && this.model.logo && this.model.logo != '') {
          this.model.url_logo = this.commonService.file(this.model.logo);
        }
      }
    });
  }

  changeFile($event) {
    const files = $event.srcElement.files;
    this.uploadService.upload(files[0]).then((res: any) => {
      if (!res.error) {
        this.model.logo = res.data;
        this.model.url_logo = this.commonService.file(this.model.logo);
        $event.target.value = null;
      } else {
        this.toastr.error(res.data.message, 'Lỗi', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    });
  }

  changeTab(tab) {
    this.tab = tab;
    this.loadData();
  }

  updateConfig() {
    delete this.model.url_logo;
    this.chatService.updateConfig(this.model).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.toastr.error('Cập nhật thất bại', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.toastr.success('Cập nhật thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          }
        }
      },
      error => {
        this.toastr.error('Cập nhật thất bại', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/chat/chat_config.component.ts